<div id="calendar-start" class="col-12 grid grid-nogutter p-fluid">
    <div class="col-12 mb-3">
        <p-panel *ngIf="selectItems | async as _selectItems" header="Események szűrése" [toggleable]="true" [collapsed]="true">
            <div class="only-big-flex items-center gap-4 my-4">
                <label class="font-semibold w-4">Tevékenységet nyújtó szervezet</label>
                <div class="flex-auto mb-4">
                    @if (!isMobile) {
                        <p-select [options]="partnerList()" optionLabel="name" optionValue="id"
                                  [fluid]="true" showClear="true"
                                  [(ngModel)]="activityFilterClientPartner"
                                  [ngModelOptions]="{standalone: true}"></p-select>
                    }
                    @if (isMobile) {
                        <select class="p-select flex text-black-alpha-90" [(ngModel)]="activityFilterClientPartner"
                                [ngModelOptions]="{standalone: true}"
                                [ngStyle]="{width: '100%', padding: '0.75rem', background: 'white', borderRadius: '4px'}">
                            <option [value]="null">-</option>
                            @for (partner of partnerList(); track $index) {
                                <option [value]="partner.id"> {{partner.name}}</option>
                            }
                        </select>
                    }
                </div>
            </div>
            <div class="only-big-flex flex-wrap gap-4 mb-2">
                <label class="font-semibold w-4">Tevékenység neve</label>
                <div class="flex-auto mb-4">
                    <input pInputText autocomplete="off" (keydown.enter)="createRequest()" [fluid]="true"
                           [(ngModel)]="activityFilterName" [ngModelOptions]="{standalone: true}"/>
                </div>
            </div>
            <div class="only-big-flex flex-wrap gap-4 mb-4">
                <label class="font-semibold w-4">Tevékenység tulajdonságai</label>
                <div class="flex-auto mb-2">
                    @if (!isMobile) {
                        <p-multiSelect [options]="getFilterCategories(_selectItems)" [fluid]="true" [filter]="true"
                                       showClear="true" scrollHeight="150px"
                                       [(ngModel)]="eventFilterCategories"
                                       [ngModelOptions]="{standalone: true}"
                                       display="chip"></p-multiSelect>
                    }
                    @if (isMobile) {
                        <select class="p-select flex text-black-alpha-90" [(ngModel)]="eventFilterCategories"
                                [ngModelOptions]="{standalone: true}" [multiple]="true"
                                [ngStyle]="{width: '100%', padding: '0.75rem', background: 'white', borderRadius: '4px'}">
                            @for (selectItems of getFilterCategories(_selectItems); track $index) {
                                <option [value]="selectItems.value"> {{selectItems.label}}</option>
                            }
                        </select>
                    }
                </div>
            </div>
            <div class="col-12" [ngStyle]="{textAlign: 'end'}">
                <button pButton
                        label="Szűrés" (click)="createRequest()" type="button"
                        [ngStyle]="{width: '150px'}"></button>
            </div>
        </p-panel>
    </div>
    <div *ngIf="isBrowser" class="col-12 text-center">
        <full-calendar #fullcalendar [options]="calendarOptions()"></full-calendar>
    </div>
</div>

@if (dialogVisible) {
    <!--p-dialog header="Esemény részletei" [modal]="true" [(visible)]="dialogVisible" [style]="{ width: '65rem' }">
        <app-event-edited-data #eventDialog [dialogVisible]="dialogVisible"
                               [applicationView]="applicationView" [startingEvent]="selectedEvent"></app-event-edited-data>
    </p-dialog-->
}

